var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"text-center",attrs:{"dense":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","dense":""}},[_c('div',{attrs:{"id":"stripe-payment-method"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }